// custom accordion script
var acc = document.getElementsByClassName("custom-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

// hiding the foating clickable when reach to footer
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 767) {
    window.addEventListener("scroll", function () {
      var footerOffset = document.getElementById(
        "shopify-section-footer"
      ).offsetTop;
      var scrollPosition = window.pageYOffset + window.innerHeight;

      var floatingContainer = document.querySelector(
        ".floating-clickable-contact-email-container"
      );
      if (scrollPosition >= footerOffset) {
        floatingContainer.style.display = "none";
      } else {
        floatingContainer.style.display = "block";
      }
    });
  }

    const marquee = document.getElementById('brandmarqueeContent');
    if (!marquee) return;
  
    let xPos = 0;
    // Duplicate the content for seamless scrolling
      marquee.innerHTML += marquee.innerHTML;
    function getSpeed() {
      const width = window.innerWidth;
      if (width <= 768) return 0.4;
      if (width <= 991) return 0.5;
      if (width <= 1024) return 0.6;
      if (width <= 1200) return 0.7;
      if (width <= 1360) return 1;
      return 0.5;
    }
  
    function animateMarquee() {
      xPos -= getSpeed();
      if (Math.abs(xPos) >= marquee.scrollWidth / 2) {
        xPos = 0;
      }
      marquee.style.transform = `translateX(${xPos}px)`;
      requestAnimationFrame(animateMarquee);
    }
  
    animateMarquee();
});
